import { PyramidView } from "components/PyramidView";
import { GameName } from "constants/difficulty";
import { SolitaireGame } from "game/SolitaireGame";
import { PyramidStrategy } from "game/strategies/PyramidStrategy";

export const getStrategyByGame = (gameName: GameName) => {
    switch (gameName) {
        case GameName.PYRAMID:
            return new PyramidStrategy({
                isShowDifficultyUI: false,
                isShowWastePilePlaceholder: true,
            });
        default:
            return undefined;
    }
}

export const getStrategyViewByGame = (gameName: GameName, game?: SolitaireGame) => {
    switch (gameName) {
        case GameName.PYRAMID:
            return new PyramidView(game);
        default:
            return undefined;
    }
}